import { X } from "lucide-react";
import type React from "react";
import type { DefaultCardProps } from "../types";

export const DefaultCard: React.FC<DefaultCardProps> = ({
  children,
  size = "md",
  className = "",
  showCloseButton = false,
  onClose,
  padding = "md",
  background = "default",
}) => {
  // Size variants based on prototype analysis
  const sizeClasses = {
    sm: "max-w-sm", // Small cards
    md: "max-w-lg", // Login, forgot-password size
    lg: "max-w-xl", // Medium-large cards
    xl: "max-w-2xl", // Register size
  };

  // Padding variants
  const paddingClasses = {
    sm: "p-4",
    md: "p-8",
    lg: "p-12",
  };

  // Background variants
  const backgroundClasses = {
    default: "bg-white/20 border border-white/30",
    glass: "bg-white/20 border border-white/30",
    "subtle-glass": "bg-white/10 border border-white/20 backdrop-blur-sm",
    solid: "bg-white border border-gray-200",
    transparent: "bg-transparent",
  };

  return (
    <div
      className={`w-full ${sizeClasses[size]} ${backgroundClasses[background]} rounded-md ${paddingClasses[padding]} ${className}`}
    >
      {/* Close Button */}
      {showCloseButton && (
        <div className="flex justify-end mb-8">
          <button
            type="button"
            onClick={onClose}
            className="p-2 bg-white/90 rounded-md hover:bg-white transition-colors cursor-pointer"
            aria-label="Close"
          >
            <X className="w-6 h-6 text-black" />
          </button>
        </div>
      )}

      {/* Card Content */}
      {children}
    </div>
  );
};

export default DefaultCard;
